import { Component, OnInit, Inject } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/core/dialog.service';
import { ToasterService } from 'src/app/services/core/toaster.service';
import { SharedDataService } from '../../shared.data.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  public passwordType: string = 'password';
  errorMessage!: string;
  public confirmPasswordType: string = 'password';
  public currentPassword: string = 'password';
  userId: any;

  public changePassword: UntypedFormGroup = new UntypedFormGroup(
    {
      password: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(12),
      ]),
      password_confirmation: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(12),
      ]),
      current_password: new UntypedFormControl(null, [Validators.required]),
    },
    { validators: this.passwordMatchValidator() }
  );
  constructor(
    public dialogService: DialogService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toasterService: ToasterService,
    private sharedDataService: SharedDataService
  ) {
    this.userId = this.data?.userData ?? null;
  }

  ngOnInit(): void {}

  getFormData = () => {
    const formValue = this.changePassword.value;
    return {
      password: formValue?.password,
      password_confirmation: formValue?.password_confirmation,
      current_password: formValue?.current_password,
    };
  };

  saveFormData = () => {
    if (this.changePassword.invalid) {
      this.touchFormControls();
      return;
    }

    if (
      this.changePassword.value.password !==
      this.changePassword.value?.password_confirmation
    ) {
      this.errorMessage = 'Passwords do not match';
      return;
    } else {
      this.errorMessage = '';
    }

    this.sharedDataService.changeUserPassword(this.userId, this.getFormData())
      .subscribe({
        next: (result:any) => {
          this.toasterService.showSuccessMessage(
            result?.data?.message ||
              result?.message ||
              'Password changed successfully'
          );
         // this.onClose(true);
          this.dialogRef.close();
        },
        error: (err:any) => {
          const msg =
            err?.error?.message || err?.message || 'Failed to change password';
          this.toasterService.showErrorMessage(msg);
        },
      });
  };

  touchFormControls() {
    Object.keys(this.changePassword.controls).forEach((key) => {
      this.changePassword.get(key)?.markAsTouched();
    });
  }

  public showPassword(field: string) {
    if (field === 'password') {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password';
    }
  }

  public showConfirmPassword(field: string) {
    if (field === 'password_confirmation') {
      this.confirmPasswordType =
        this.confirmPasswordType === 'password' ? 'text' : 'password';
    }
  }

  public showCurrentPassword(field: string) {
    if (field === 'current_password') {
      this.currentPassword =
        this.currentPassword === 'password' ? 'text' : 'password';
    }
  }

  generateRandomPassword(length: number): string {
    const charset =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+[]{}|;:,.<>?';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset.charAt(randomIndex);
    }
    return password;
  }

  generateAndSetPassword() {
    const newPassword = this.generateRandomPassword(12);
    this.changePassword.patchValue({
      password: newPassword,
    });
  }

  generateAndSetConfirmPassword() {
    const newPassword = this.generateRandomPassword(12);
    this.changePassword.patchValue({
      password_confirmation: newPassword,
    });
  }

  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get('password');
      const confirmPassword = control.get('password_confirmation');

      if (
        password &&
        confirmPassword &&
        password.value !== confirmPassword.value
      ) {
        return { passwordsMismatch: true };
      }
      return null;
    };
  }

  onClose = (data: any = '') => {
    this.dialogRef.close(data);
  };
}